import * as React from 'react';
import * as styles from './Promos.css';
import { CollapsedBlock, ICollapsedButtonProps } from '../CollapsedBlock';
export interface IPromos {
  defaultOpened?: boolean;
  Button: React.ComponentType<ICollapsedButtonProps>;
}

export function Promos({ defaultOpened, children, Button }: React.PropsWithChildren<IPromos>) {
  return (
    <div data-testid="Promos" className={styles['promos']} id="promoList">
      <div className={styles['promos-list']}>
        <CollapsedBlock collapsedHeight={524} Button={Button} opened={defaultOpened}>
          <div className={styles['container']}>{children}</div>
        </CollapsedBlock>
      </div>
    </div>
  );
}
